import { Checkbox, Form, List, Typography } from "antd";
import React from "react";
import get from "lodash/get";

const SelectTemplates = ({ templates }) => {
  const { Title } = Typography;
  return (
    <Form.Item
      name="template_access"
      label={<Title level={5}>Select Template</Title>}
      rules={[
        {
          required: true,
          message: "Please select at least one template!",
        },
      ]}
    >
      <Checkbox.Group className="w-full" onChange={(data) => {}}>
        <List
          className="w-full"
          dataSource={Object.values(templates)}
          renderItem={(template) => (
            <List.Item>
              <Checkbox value={get(template, "value")}>
                {get(template, "name")}
              </Checkbox>
            </List.Item>
          )}
        ></List>
      </Checkbox.Group>
    </Form.Item>
  );
};

export default SelectTemplates;
